/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    name: "VisitAddEditModal",
    components: { customModal, flatPickr },
    props: { managevisitobj: Object },
    emits: ["closeModal", "saveVisit"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            showCreateLoader: false,
            token: store.getters.getIdToken,
            studyId: store.getters.getStudyIs,
            visitName:"",
            visitNo:  "",
            dateTimePickerConfig: {
                enableTime: true,
                time_24hr: true,
                dateFormat:"Y-m-d H:i",
                allowInput: true
            },

            form: this.data || {
                visitStatus: "",
                actualStartDate: "",
                actualEndDate: "",
                plannedVisitDate: "",
                isActivated: true,
                cycleName: "",
                cycleId: 0,
                occurrence: 0
            },
            cycleList: [],
            Status: [],
            selectedCycleId: "",

            errors: {
                visitStatus: ""
            }
        };
    },

    computed: {
        isEditMode() {
            return !!this.data;
        },
        sortedCycleList() {
            return [...this.cycleList].sort((a, b) =>
                a.cycleName.localeCompare(b.cycleName)
            );
        }

    },
    async mounted() {
        console.log("ManageVisit mounted with data:", this.managevisitobj);
        await this.fetchCycleList();
        await this.getAllVisitStatus();
        this.mapVisitData();
    },

    methods: {
        closeModal() {
            this.$emit("closeModal");
        },


        formatToISO(date) {
            return date ? moment(date).toISOString() : null;
        },

        async save() {
            this.showCreateLoader = true;
            let payload = {
                studyId: this.managevisitobj.studyId,
                subjectId: this.managevisitobj.patientId,
                visitNumber: this.managevisitobj.visitNo,
                visitStatus: this.form.visitStatus || null,
                actualStartDate: this.form.actualStartDate
                    ? this.toApiDate(this.form.actualStartDate)
                    : null,
                actualEndDate: this.form.actualEndDate
                    ? this.toApiDate(this.form.actualEndDate)
                    : null,
                plannedVisitDate: this.form.plannedVisitDate
                    ? this.toApiDate(this.form.plannedVisitDate)
                    : null,
                isActivated: true,
                cycleName: this.form.cycleName || null,
                cycleId: Number(this.form.cycleId) || null,
                occurrence: Number(this.form.occurrence) || null
            };

            try {
                await axios.put(
                    `${this.baseurl}/management/patientschedule/managevisit`,
                    payload,
                    {
                        headers: { Authorization: `Bearer ${this.token}` }
                    }
                );

                alert("Visit saved successfully");
                this.$emit("saveVisit");
                this.closeModal();

            } catch (err) {
                console.error("Save failed", err);
                alert("Failed to save Visit");
            }
            finally {
                this.showCreateLoader = false;
            }
        },
        formatDateTimeForInput(value) {
            if (!value) return null;
            const formatted = moment(value).utc().format("YYYY-MM-DDTHH:mm");
            return formatted === "Invalid date" ? null : formatted;
        },
        async fetchCycleList() {
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/cycle/listcycles?studyId=${this.studyId}&SortProperty=cycleName&SortOrder=0`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );

                this.cycleList = Array.isArray(response.data?.entities)
                    ? response.data.entities
                    : [];
                console.log("Fetched cycle list:", this.cycleList);

            } catch (err) {
                console.error("Failed to load cycle list:", err);
                this.cycleList = [];
            }
        },
        async getAllVisitStatus() {
            await axios
                .get(`${this.baseurl}/management/statusmaster/getall?StatusType=Visit`, {
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    this.Status = response.data

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onCycleChange() {
            const selected = this.cycleList.find(
                c => c.cycleId === this.selectedCycleId
            );

            this.form.cycleId = selected?.cycleId || null;
            this.form.cycleName = selected?.cycleName || null;
        },
        toApiDate(dateTimeValue) {
            if (!dateTimeValue) return null;

            const parsed = moment.utc(dateTimeValue, "YYYY-MM-DD HH:mm", true);

            return parsed.isValid()
                ? parsed.format("YYYY-MM-DDTHH:mm:ss[Z]")
                : null;
        },
        
        mapVisitData() {
            if (!this.managevisitobj) return;

            this.form.visitStatus = this.managevisitobj.visitStatus || "";
            this.visitName = this.managevisitobj.visitName || "";
            this.visitNo = this.managevisitobj.visitNo || "";


            this.form.plannedVisitDate = this.managevisitobj.visitDate
                ? this.formatDateTimeForInput(this.managevisitobj.visitDate)
                : "";

            this.form.actualStartDate = this.managevisitobj.actualVisitStartDate
                ? this.formatDateTimeForInput(this.managevisitobj.actualVisitStartDate)
                : "";

            this.form.actualEndDate = this.managevisitobj.actualVisitEndDate
                ? this.formatDateTimeForInput(this.managevisitobj.actualVisitEndDate)
                : "";

            this.form.cycleName = this.managevisitobj.cycleName || "";
            this.form.cycleId = this.managevisitobj.cycleId || null;
            this.form.occurrence = this.managevisitobj.occurence || null;


            this.selectedCycleId = this.managevisitobj.cycleId || "";
        }
    }
};